<div
	class="w-screen h-screen overflow-y-auto lg:border-r lg:sticky lg:mr-10 lg:top-0 lg:w-76"
	[ngClass]="{
		'lg:overflow-y-scroll': !autoSuggestOpen(),
		'lg:overflow-y-hidden': autoSuggestOpen(),
	}"
>
	<aside class="px-4 pb-20 bg-white lg:pr-10 lg:pl-0" id="filter-component">
		<div class="flex flex-col h-full" role="search">
			<div class="flex items-center justify-between pt-6 lg:pt-0">
				<p class="text-lg font-bold">Search & Filters</p>
				<!-- reset filter -->
				<button
					type="button"
					aria-expanded="false"
					aria-controls="filter-component"
					(click)="resetFiltersAndNavigate()"
					class="text-xs text-gray-500 border-b border-gray-500 lg:inline-block only-tab-focus hover:text-gray-700"
				>
					Reset filters
				</button>
				<!-- close filter -->
				<button
					(click)="closeFilter.emit(true)"
					aria-controls="filter-component"
					class="p-2 bg-gray-200 rounded-md lg:hidden"
				>
					<uc-close-modal-svg customStyles="stroke-gray-500" />
				</button>
			</div>

			<div class="w-full my-6 border-b border-gray-500"></div>

			<div class="flex flex-col w-full gap-3 pb-6 border-b border-gray-500">
				<!-- search -->
				<uc-course-finder
					[subject]="subject()"
					errorPosition="bottom"
					[disableError]="disableError()"
					(autosuggest)="autosuggest.emit($event)"
					context="filter"
					searchLocation="Course Search Filter"
				/>

				<!-- clearing checkbox-->
				@if (clearingEnabled) {
					<uc-clearing-checkbox
						class="flex items-center mt-3"
						[product]="studyLevel()"
						searchType="course"
						(changeClearingChecked)="onClearingSelect($event)"
					/>
				}
			</div>

			<!-- STUDY LEVEL -->
			<uc-study-level-select
				class="py-6 border-b border-gray-500"
				[studyLevel]="studyLevel()"
				description="
					This shows universities offering {{
					studyLevel()
				}} courses, and changes the order, filters and next steps available for your search.
				"
				(studyLevelChange)="onStudyLevel($event)"
			/>

			<!-- FILTER PILLS -->
			<uc-course-search-filter-pills
				[filterPills]="filterPills()"
				(removePill)="onRemovePill($event)"
				(resetFilters)="resetFiltersAndNavigate()"
			/>

			<!-- DEGREE LEVEL -->
			@if (showDegreeLevel()) {
				<uc-radio-select
					filterTitle="Degree Level"
					filterName="degreeLevels"
					[options]="degrees()()"
					[tooltips]="tooltips"
					[state]="courseSearchFilterStateSrv.degreeLevels"
					(selected)="onDegreeSelect($event)"
					(filterState)="onFilterState($event)"
				/>
			}

			<!-- LOCATION -->
			@if (showLocation()) {
				<uc-radio-select
					filterTitle="Location"
					filterName="locations"
					[options]="locations"
					[state]="courseSearchFilterStateSrv.locations"
					(selected)="onLocationSelect($event)"
					(filterState)="onFilterState($event)"
				/>
			}

			<!-- UCAS TARIFF -->
			@if (studyLevel() !== 'postgraduate') {
				<uc-ucas-input
					filterName="ucasPoints"
					[minValue]="ucasPoints()[0]"
					[maxValue]="ucasPoints()[1]"
					[state]="courseSearchFilterStateSrv.ucasPoints"
					(setUcasPoints)="onUcasPointsSelect($event)"
					(filterState)="onFilterState($event)"
				/>
			}

			<!-- STUDY OPTIONS -->
			<uc-radio-select
				filterTitle="Study Options"
				filterName="studyOptions"
				[options]="studyOptions"
				[state]="courseSearchFilterStateSrv.studyOptions"
				(selected)="onQueryParamsUpdate($event)"
				(filterState)="onFilterState($event)"
			/>
		</div>
	</aside>
</div>
